import React, { Component } from 'react';
import { bool, arrayOf, shape, number } from 'prop-types';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { push } from 'connected-react-router';
import { reducerAccumulator } from '@widergy/web-utils/lib/array';

import { ROUTES } from 'constants/routes';
import { actionCreators as accountActions, accountPropTypes } from 'redux/accountHandlers';
import { actionCreators as paymentActions } from 'redux/paymentHandlers';
import { unpaidBillType } from 'types/paymentTypes';
import WithoutAccounts from 'app/components/WithoutAccounts';
import { appConfig } from 'config/customization';
import { gaTrackPageView } from 'services/AnalyticsService';

import styles from './styles';
import ClientSummaryScene from './layout';

class ClientSummarySceneContainer extends Component {
  componentDidMount() {
    gaTrackPageView(ROUTES.CLIENT_SUMMARY);
    this.props.dispatch(paymentActions.getUserUnpaidBills(this.props.accounts));
  }

  handleSelectAccount = clientNumber => {
    const currentAccount = this.props.accounts.find(account => account.client_number === clientNumber);
    this.props.dispatch(accountActions.changeCurrentAccount(currentAccount));
    this.props.dispatch(push(appConfig.payments.active ? ROUTES.PAYMENTS : ROUTES.ACCOUNT_STATUS));
  };

  handlePayment = () => {
    const totalAmount = this.props.unpaid && this.props.unpaid.balance;
    const amountList = this.props.unpaid && this.props.unpaid.bills;
    this.props.dispatch(paymentActions.paymentFlowInit(totalAmount, amountList));
  };

  handleExternalAccPayment = () => {
    this.props.dispatch(push(ROUTES.EXTERNAL_PAYMENTS));
  };

  render() {
    return (
      <div style={styles.container}>
        <ClientSummaryScene
          loading={this.props.accountsLoading || this.props.unpaidLoading}
          accounts={this.props.accounts}
          handleSelectAccount={this.handleSelectAccount}
          handlePayment={this.handlePayment}
          handleExternalAccPayment={this.handleExternalAccPayment}
        />
      </div>
    );
  }
}

const unpaidSelector = createSelector(
  store => store.payment.userUnpaidBills,
  userUnpaidBills => ({
    balance: userUnpaidBills
      .filter(element => element.payable)
      .map(item => item.balance)
      .reduce(reducerAccumulator, 0),
    bills:
      userUnpaidBills
        .filter(element => element.payable)
        .map(bill => ({
          client_number: bill.client_number,
          external_id: bill.external_id,
          amount: bill.balance || bill.amount
        })) || []
  })
);

const accountsSelector = store =>
  store.account.accounts.map(account => ({ ...account, external_id: account.id }));

const mapStateToProps = store => ({
  accounts: accountsSelector(store),
  accountsLoading: store.account.accountsLoading,
  unpaid: unpaidSelector(store),
  unpaidLoading: store.payment.userUnpaidBillsLoading,
  paymentRequestLoading: store.payment.paymentRequestLoading,
  accountsError: store.account.accountsError
});

ClientSummarySceneContainer.propTypes = {
  accounts: arrayOf(accountPropTypes),
  accountsLoading: bool.isRequired,
  unpaidLoading: bool,
  unpaid: shape({
    balance: number,
    bills: arrayOf(unpaidBillType)
  })
};

export default connect(mapStateToProps)(
  WithoutAccounts({
    shouldShowMessage: props => props.accounts.length === 0 && !props.accountsLoading,
    accountsError: props => props.accountsError
  })(ClientSummarySceneContainer)
);
